// import * as firebase from 'firebase/app';
// import 'firebase/auth';
// import 'firebase/database';
// import 'firebase/storage';

// require("firebase/app");
// require("firebase/auth");
// require("firebase/database");
// require("firebase/firestore");
// require("firebase/messaging");
// require("firebase/functions");

// import firebase from 'firebase'

const firebase = window.firebase;


var firebaseConfig = {
  apiKey: "AIzaSyDV8n9F6rLKRzgG7KEJeIcoKf_MoYx7p74",
  authDomain: "obat-io.firebaseapp.com",
  databaseURL: "https://obat-io.firebaseio.com",
  projectId: "obat-io",
  storageBucket: "obat-io.appspot.com",
  messagingSenderId: "959709470938",
  appId: "1:959709470938:web:265ee218f6c9c15d",
  measurementId: "G-KMYN7F5Z0C"
};

const firebaseApp = firebase.initializeApp(firebaseConfig)
// const firebaseAppUkai = firebase.initializeApp({databaseURL: "https://obat-io-ukai.firebaseio.com"}, 'UKAI')
// const firebaseAppPublicData = firebase.initializeApp({databaseURL: "https://obat-io-public-data.firebaseio.com"}, 'PublicData')



const MainDatabaseRef = firebaseApp.database().ref()
const UkaiDatabaseRef = firebaseApp.database('https://obat-io-ukai.firebaseio.com').ref()
const PublicDataDatabaseRef = firebaseApp.database('https://obat-io-public-data.firebaseio.com').ref()

export {
  firebase,
  firebaseApp,
  MainDatabaseRef,
  UkaiDatabaseRef,
  PublicDataDatabaseRef,
}